import { createStore } from 'vuex'
import operate_inspection_plan from './inspection_plan'
import operate_inspection_type from './inspection_type'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('operate_inspection_type/clearAll', null, { root: true })
      dispatch('operate_inspection_plan/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('operate_inspection_type/clearAll', null, { root: true })
      dispatch('operate_inspection_plan/clearAll', null, { root: true })
    },
  },
  modules: {
    operate_inspection_type,
    operate_inspection_plan,
  },
})

export default store
